const pt = {
  common: {
    save: "Salvar",
    cancel: "Cancelar",
    edit: "Editar",
    delete: "Excluir",
    discard: "Descartar",
    loading: "Carregando...",
    search: "Buscar",
    filter: "Filtrar",
    all: "Todos",
    actions: "Ações",
    yes: "Sim",
    no: "Não",
    close: "Fechar",
    send: "Enviar",
    refresh: "Atualizar",
    sign_out: "Sair",
    map: "Mapa",
    email: "Email",
    add: "Adicionar",
    optional: "Opcional",
    required: "Obrigatório",
    status: "Status",
    date: "Data",
    name: "Nome",
    phone: "Telefone",
    address: "Endereço",
    notes: "Observações",
    total: "Total",
    export: "Exportar",
  },
  nav: {
    overview: "Visão Geral",
    inventory: "Estoque",
    layouts: "Layouts",
    orders: "Pedidos",
    appointments: "Agendamentos",
    availability: "Disponibilidade",
    customers: "Clientes",
    leads: "Leads",
    permits: "Permits",
    ads: "Meta Ads",
    landing: "Landing Page",
    analytics: "Analytics",
    financials: "Financeiro",
    profit: "Apuração de Lucro",
    projects: "Projetos",
    ai: "IA & Insights",
    seo: "SEO",
    legal: "Jurídico",
    sales_list: "Lista Vendedores",
    settings: "Configurações",
  },
  nav_groups: {
    main: "Principal",
    operations: "Operações",
    sales: "Vendas & CRM",
    marketing: "Marketing & SEO",
    finance: "Financeiro",
    system: "Sistema",
  },
  header: {
    admin_dashboard: "Painel do Admin",
    sales_dashboard: "Painel de Vendas",
    language: "Idioma",
  },
  pages: {
    overview: "Visão Geral do Painel",
    customers: "Clientes",
    leads: "Leads",
    orders: "Pedidos",
    permits: "Building Permits — Captação de Leads",
  },
  overview: {
    range: { "7d": "7 dias", "30d": "30 dias", "90d": "90 dias", all: "Tudo" },
    kpis: {
      total_revenue: "Receita Total",
      orders_suffix: "{{count}} pedidos",
      avg_project: "Valor Médio do Projeto",
      per_order: "Por pedido",
      deposit_install: "Depósito → Instalação",
      deposit_of: "{{a}} de {{b}}",
      expiration_rate: "Taxa de Expiração",
      expired: "{{count}} expirados",
    },
    mini: {
      slabs: "Chapas",
      orders: "Pedidos",
      appointments: "Agendamentos",
      customers: "Clientes",
    },
    charts: {
      revenue_trend: "Tendência de Receita",
      revenue_trend_desc: "Receita e depósitos mensais ao longo do tempo",
      no_orders: "Sem dados de pedidos ainda — o gráfico será preenchido conforme entrarem pedidos",
      revenue: "Receita",
      deposits: "Depósitos",
      material_dist: "Distribuição por Material",
      revenue_share: "Participação na receita por material",
      catalog_no_revenue: "Materiais no catálogo (sem dados de receita ainda)",
      conversion_funnel: "Funil de Conversão",
      funnel_desc: "Pipeline de quotes a pedidos concluídos",
      from_prev: "{{rate}}% de {{prev}}",
      stages: { quotes: "Quotes", reservations: "Reservas", orders: "Pedidos", completed: "Concluídos" },
      revenue_by_material: "Receita por Material",
      revenue_by_material_desc: "Desempenho agregado por tipo de material",
      internal: "Interno",
      no_material_data: "Sem dados de material ainda",
      total_revenue_label: "Receita Total",
      avg_order_label: "Valor Médio do Pedido",
    },
    margin: {
      title: "Estimativa de Margem",
      confidential: "Confidencial",
      desc: "Baseado em custo interno vs valor cobrado do cliente",
      empty: "Defina internal_price_per_sqft em Configurações para habilitar o tracking de margem",
      headers: { material: "Material", customer: "Cliente $/sqft", internal: "Interno $/sqft", margin: "Margem est.", revenue: "Receita" },
    },
    reservations: {
      title: "Padrões de Reserva",
      desc: "Duração de reservas e métricas de conversão",
      active: "Ativas",
      converted: "Convertidas",
      expired: "Expiradas",
      avg_hold: "Tempo médio",
    },
    device: {
      title: "Conversão por Dispositivo",
      desc: "Requer encaminhamento server-side de eventos do GTM. Dados de dispositivo ainda não armazenados.",
    },
  },
  leads: {
    kpis: { total: "Total de Leads", new: "Leads Novos", quoted: "Cotados" },
    search: "Buscar leads...",
    headers: { name: "Nome", email: "Email", phone: "Telefone", city: "Cidade", project: "Projeto", status: "Status", date: "Data" },
    empty: "Nenhum lead ainda",
    details: "Detalhes do Lead",
    company: "Empresa",
    timeline: "Prazo",
    preferred_contact: "Contato preferido",
    notes: "Observações",
    quote: "Quote",
    linked: "Vinculado",
    status: {
      new_lead: "novo lead",
      quoted: "cotado",
      contacted: "contatado",
      converted: "convertido",
      appointment_scheduled: "agendamento marcado",
    },
  },
  customers: {
    kpis: { total: "Total de Clientes", new_week: "Novos esta semana", showing: "Exibindo", matching: "resultados" },
    add: "Adicionar Cliente",
    search: "Buscar por nome, email ou telefone...",
    show_deleted: "Mostrar excluídos",
    no_name: "Sem nome",
    loading: "Carregando clientes...",
    none_search: "Nenhum cliente corresponde à busca.",
    none: "Nenhum cliente cadastrado ainda.",
    active: "Ativo",
    deleted: "Excluído",
    headers: { name: "Nome", email: "Email", phone: "Telefone", status: "Status", registered: "Cadastro", actions: "Ações" },
    actions: { create_order: "Criar Pedido", edit: "Editar", delete: "Excluir", restore: "Restaurar" },
    add_dialog: { title: "Adicionar Cliente", desc: "Criar um novo cliente manualmente.", adding: "Adicionando..." },
    edit_dialog: { title: "Editar Cliente", desc: "Atualizar dados do cliente.", save: "Salvar Alterações" },
    delete_dialog: { title: "Excluir cliente?", desc: "Isto vai excluir \"{{name}}\" (soft delete). Ele não aparecerá na lista ativa mas poderá ser restaurado." },
    order_dialog: {
      title: "Criar Pedido para {{name}}",
      desc: "Criar um novo pedido para este cliente. Todos os detalhes podem ser editados depois.",
      customer: "Cliente",
      amount: "Valor inicial ($)",
      amount_placeholder: "0,00 — pode ser definido depois",
      amount_help: "Opcional. Você pode ajustar o valor total na página do pedido.",
      create: "Criar Pedido",
    },
    form: {
      full_name: "Nome Completo *",
      email: "Email *",
      password: "Senha *",
      password_placeholder: "Defina uma senha padrão",
      password_help: "Mínimo 6 caracteres. O cliente pode alterar após o login.",
      phone: "Telefone",
      address: "Endereço",
      notes: "Observações (interno)",
      send_welcome: "Enviar email de boas-vindas com as credenciais",
    },
    toasts: {
      updated: "Cliente atualizado",
      added: "Cliente adicionado",
      added_email: "Email de boas-vindas enviado com as credenciais.",
      order_created: "Pedido criado",
    },
  },
  orders: {
    new: "Novo Pedido",
    kpis: { total: "Total", pending: "Pendentes", in_progress: "Em Andamento", completed: "Concluídos" },
    quotes_pending: "Quotes de Clientes — Ainda Não Convertidas em Pedido",
    quote_headers: { id: "ID do Quote", customer: "Cliente", material: "Material", sqft: "Sq Ft", est_total: "Total Estimado", status: "Status", date: "Data", actions: "Ações" },
    guest: "Visitante",
    create_order: "Criar Pedido",
    search: "Buscar por cliente ou ID do pedido...",
    filters: { all: "Todos os Status", pending: "Pendente", confirmed: "Confirmado", in_progress: "Em Andamento", completed: "Concluído", cancelled: "Cancelado" },
    loading: "Carregando pedidos...",
    none: "Nenhum pedido encontrado.",
    headers: { id: "ID Pedido", customer: "Cliente", total: "Total", deposit: "Depósito", status: "Status", date: "Data", actions: "Ações" },
    send_estimate: "Enviar orçamento ao cliente",
    delete_order: { title: "Tem certeza que deseja excluir este pedido?", desc: "Esta ação não pode ser desfeita." },
    delete_quote: { title: "Tem certeza que deseja excluir este quote?", desc: "Esta ação não pode ser desfeita." },
    toasts: {
      deleted: "Pedido excluído",
      delete_failed: "Falha ao excluir pedido",
      quote_deleted: "Quote excluído",
      created_from_quote: "Pedido criado a partir do quote",
      no_email: "Cliente sem email",
      auto_confirmed: "{{count}} pagamento(s) confirmado(s) automaticamente",
    },
  },
  permits: {
    subtitle: "Sarasota, Manatee e Charlotte.",
    tabs: { list: "Lista de Permits", how: "Como funciona" },
    filters: {
      county: "Condado",
      tier: "Tier",
      status: "Status",
      all_counties: "Todos os condados",
      all_tiers: "Todos os tiers",
      all_statuses: "Todos os status",
    },
    tier: { gold: "Gold", silver: "Silver", bronze: "Bronze", cold: "Cold" },
    status: {
      new: "Novo",
      contacted: "Contatado",
      converted: "Convertido",
      discarded: "Descartado",
    },
    no_address: "(sem endereço)",
    empty: "Nenhum permit ainda. Rode um scraper acima ou adicione manualmente.",
    fields: {
      type: "Tipo",
      date: "Data",
      permit_value: "Permit",
      property_value: "Imóvel",
      contractor: "Empreiteiro",
      owner: "Proprietário",
      score_breakdown: "Detalhe do score",
      ai_copy: "Copy gerada por IA",
      postal: "Postal",
      email_label: "Email",
      facebook_ad: "Anúncio Facebook",
    },
    actions: {
      gen_copy: "Gerar copy",
      mark_contacted: "Marcar contatado",
      mark_converted: "✓ Convertido",
      discard: "Descartar",
      manual: "Manual",
      add_manual: "Adicionar Permit Manualmente",
      run_scraper: "Rodar scraper",
      add_score: "Adicionar & pontuar",
    },
    email_dialog: {
      title: "Enviar email para {{address}}",
      recipient: "Destinatário",
      subject: "Assunto",
      body: "Corpo",
      send: "Enviar",
    },
    manual_form: {
      permit_number: "Número do permit *",
      county: "Condado",
      project_type: "Tipo de projeto",
      issued_date: "Data de emissão",
      address: "Endereço",
      city: "Cidade",
      zip: "CEP",
      permit_value: "Valor do permit $",
      property_value: "Valor do imóvel $",
      contractor: "Empreiteiro",
      owner_name: "Nome do proprietário",
      owner_email: "Email do proprietário (opcional)",
      description: "Descrição",
      cat: {
        kitchen_remodel: "Reforma de cozinha",
        bath_remodel: "Reforma de banheiro",
        new_construction: "Nova construção",
        addition: "Ampliação",
        other: "Outro",
      },
    },
    toasts: {
      scraper: "{{county}}: {{inserted}} novos, {{updated}} atualizados",
      scraper_failed: "Falha no scraper",
      copy_generated: "Copy gerada",
      copy_failed: "Falha ao gerar copy",
      updated: "Atualizado",
      email_sent: "Email enviado",
      email_queued: "Salvo na fila",
      permit_added: "Permit adicionado, pontuado e copy gerada",
      permit_number_required: "Número do permit é obrigatório",
    },
    how: {
      title: "Como o sistema funciona",
      scrape: "<b>Scrape:</b> os botões acima rodam o Firecrawl no portal do condado e extraem permits recentes.",
      score: "<b>Score automático (0–100):</b> regras determinísticas pontuam o lead baseado em tipo de obra, valor do permit, valor do imóvel e data.",
      tier: "<b>Tier:</b> 75+ Gold · 50–74 Silver · 25–49 Bronze · <25 Cold.",
      copy: "<b>Copy IA:</b> para Gold/Silver, gera texto pronto de postal, email e anúncio de Facebook.",
      send: "<b>Envio:</b> o botão Email envia via Resend (se conectado) ou guarda na fila para envio manual.",
      manual: "<b>Manual:</b> qualquer permit descoberto por outro canal pode ser adicionado pelo botão \"+\" acima.",
      note: "Para envio automático, conecte o Resend em Workspace → Connectors.",
    },
  },
  sales_list: {
    title: "Lista para Vendedores",
    subtitle: "Selecione quem compartilhar. Os vendedores veem nome, telefone, endereço, projeto e a ordem de serviço.",
    link_card: "Link dos vendedores",
    copy: "Copiar",
    shared_card: "Na lista compartilhada ({{count}})",
    shared_empty: "Nenhum cliente compartilhado ainda.",
    select_card: "Selecionar clientes",
    search: "Buscar nome, telefone, cidade...",
    add: "Adicionar ({{count}})",
    open: "Abrir",
    remove: "Remover da lista",
    select_aria: "Selecionar {{name}}",
    already: "já na lista",
    headers: { name: "Nome", phone: "Telefone", address: "Endereço", project: "Projeto", order: "Ordem", source: "Origem", info: "Mais informações" },
    info: { placeholder: "Adicione informações para o vendedor...", saved: "Informações salvas", save_error: "Erro ao salvar informações" },
    source: { lead: "Lead", appointment: "Agendamento", order: "Ordem", customer: "Cliente", manual: "Manual" },
    csv_file: "lista-vendedores.csv",
    reps: {
      card: "Vendedores",
      desc: "Cada vendedor tem a própria planilha do Google apenas com os clientes atribuídos a ele.",
      name_placeholder: "Nome do vendedor",
      add: "Criar link",
      copy: "Copiar link",
      remove: "Excluir vendedor",
      empty: "Nenhum vendedor cadastrado.",
      unassigned: "Sem vendedor",
      header: "Vendedor",
      created: "Link do vendedor criado",
      create_error: "Falha ao criar vendedor",
      removed: "Vendedor excluído",
      assign_error: "Falha ao atribuir vendedor",
      name_required: "Informe o nome do vendedor",
    },
    sheet: {
      card: "Planilha do Google",
      desc: "Sincronize a lista selecionada com uma planilha do Google para os vendedores acessarem.",
      sync: "Sincronizar agora",
      syncing: "Sincronizando...",
      open: "Abrir planilha",
      not_created: "A planilha é criada automaticamente na primeira sincronização.",
      synced: "Planilha atualizada ({{count}} registros)",
      sync_error: "Erro ao sincronizar a planilha",
    },
    attachments: {
      header: "Anexos",
      add: "Anexar PDF",
      uploading: "Enviando...",
      remove: "Remover anexo",
      none: "—",
      only_pdf: "Envie apenas arquivos PDF.",
      too_large: "Arquivo muito grande (máx. 15 MB).",
      uploaded: "Anexo adicionado",
      upload_error: "Erro ao anexar arquivo",
      removed: "Anexo removido",
      remove_error: "Erro ao remover anexo",
    },
    toasts: {
      load_error: "Erro ao carregar",
      nothing_to_add: "Nada para adicionar",
      nothing_to_add_desc: "Selecione clientes que ainda não estão na lista.",
      add_error: "Erro ao adicionar",
      added: "{{count}} cliente(s) adicionado(s) à lista",
      remove_error: "Erro ao remover",
      link_copied: "Link copiado",
      link_copied_desc: "Envie para os vendedores.",
    },

    public: {
      title: "Clientes — Equipe de Vendas",
      subtitle: "Lista compartilhada pela Altar Stones. Uso interno.",
      count: "{{count}} cliente(s)",
      loading: "Carregando...",
      unavailable: "Indisponível",
      empty: "Nenhum cliente compartilhado no momento.",
      no_order: "Sem ordem",
      work_order: "Ordem de serviço",
      invalid_token: "Link inválido — token ausente.",
      expired: "Link inválido ou expirado.",
      load_error: "Erro ao carregar a lista ({{status}}).",
      generic_error: "Não foi possível carregar a lista.",
      pdf_error: "Erro ao gerar PDF",
      pdf: {
        title: "Ordem de Serviço",
        customer: "Cliente",
        specs: "Especificações",
        values: "Valores",
        name: "Nome",
        phone: "Telefone",
        address: "Endereço",
        project: "Projeto",
        material: "Material",
        color: "Cor",
        finish: "Acabamento",
        edge: "Perfil de borda",
        sqft: "Medidas (sqft)",
        scope: "Scope of Work",
        subtotal: "Subtotal",
        tax: "Tax",
        total: "Total",
        deposit: "Depósito pago",
        status: "Status da ordem",
      },
    },
  },
};

export default pt;
